import React from "react";

class Butt extends React.Component {
  render() {
    return (<div>
      <button id="loginx" type={this.props.type} disabled={this.props.loading} className={this.props.clas}
              onClick={this.props.clik}>
        {this.props.name}
      </button>
    </div>);
  }
}
Butt.propTypes = {
  type: React.PropTypes.string,
  clas: React.PropTypes.string,
  clik: React.PropTypes.func,
  loading: React.PropTypes.bool,
  name: React.PropTypes.string

};
Butt.defaultProps = {
  type: "button",
  clas: "",
  name: "button",
  link_text: "",
  link_clas: "",
  loading: false

};

export default Butt;



/** WEBPACK FOOTER **
 ** ./src/react/components/Button.js
 **/